import { render, staticRenderFns } from "./policy-edit-mode.vue?vue&type=template&id=7ce4a946&scoped=true"
import script from "./policy-edit-mode.vue?vue&type=script&lang=js"
export * from "./policy-edit-mode.vue?vue&type=script&lang=js"
import style0 from "./policy-edit-mode.vue?vue&type=style&index=0&id=7ce4a946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce4a946",
  null
  
)

export default component.exports